import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class OrganismsApproachPlanListComponent extends Component {
  @tracked openWeek;

  @action
  toggleWeek() {
    this.args.week.weekOpen = !(this.args.week.weekOpen ?? false);
    this.openWeek = this.args.week.weekOpen;
  }

  get weekHasNotes() {
    return !(
      this.args.week.text_delta === undefined ||
      this.args.week.text_delta?.ops?.length === 0 ||
      this.args.week.text_delta?.ops?.[0]?.insert === '\n'
    );
  }
}
